export enum SENDER_TYPE {
  USER = 'user',
  AGENT = 'agent'
}

export enum MESSAGE_TYPE {
  TEXT = 'text',
  ACTION_CARD = 'action_card',
  TIMEOUT_END = 'timeout_end',
  TIMEOUT_WARNING = 'timeout_warning',
  SELECT_ORDER = 'select_order',
  SESSION_DIVIDER = 'session_divider' // 历史会话分隔线
}

export const TIMEOUT_WARNING_MS = 1000 * 60 * 2
export const TIMEOUT_END_MS = 1000 * 30

// 订单状态映射
export const ORDER_STATUS_MAP: Record<number, string> = {
  0: '已关闭',
  15: '待支付',
  20: '待接单',
  21: '重新派单',
  30: '已接单',
  40: '致电寄件人',
  42: '已就位',
  44: '已取件',
  46: '用户申请取消',
  47: '不同意用户取消',
  48: '同意用户取消',
  52: '致电收件人',
  60: '已完成',
  62: '部分完成',
  64: '已取消，流单'
}
// 一取多投订单状态映射一会
export const ORDER_MORE_STATUS_MAP: Record<number, string> = {
  0: '未派送',
  1: '已完成',
  2: '已取消',
  3: '已致电收方'
}
